module.exports = __webpack_public_path__ + "img/4-3.ea5d64b5.png";